/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-04-10 16:52:56
 * @Description: 维保项目管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const wbxmService = {

  // 维保项目查询
  query: (params) => { return axios.get(`${iffApi}/xfwb/wbxm`, { params: params }); },

  // 作废
  delete: (id) => { return axios.delete(`${iffApi}/xfwb/wbxm/${id}`); },

  // 更新
  update: (fd) => { return axios.put(`${iffApi}/xfwb/wbxm`, fd); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfwb/wbxm/export`, { responseType: 'blob', params }); },

  // 获取项目维保内容列表
  getKhWbnrList: (id) => { return axios.get(`${iffApi}/xfwb/wbxm/wbnr/${id}`); },

  // 获取系统维保内容列表
  getXtWbnrList: () => { return axios.get(`${iffApi}/xfwb/wbxm/wbnrAll`); },

  // 获取项目维保内容列表
  getWbnrList: (xmId, zyzq) => { return axios.get(`${iffApi}/xfwb/wbxm/${xmId}/${zyzq}`); },

  // 获取维保项目详情
  getWbxmInfo: (id) => { return axios.get(`${iffApi}/xfwb/wbxm/${id}`); },

  // 获取“合同有效”客户列表
  getYxxmList: (params) => { return axios.get(`${iffApi}/xfwb/wbxm/htyxxm`, { params: params }); },

  // 查询
  queryXmjh: (id) => { return axios.get(`${iffApi}/xfwb/wbxm/wbjh/${id}`); },

  // 删除
  deleteXmjh: (id) => { return axios.delete(`${iffApi}/wbjh/${id}`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfwb/wbxm`, fd); },

  // 获取可转移用户列表
  getTranslateUsers: (xmId) => { return axios.get(`${iffApi}/xfwb/wbxm/xmusers/${xmId}`); },

  // 项目转移
  translate: (fd) => { return axios.post(`${iffApi}/xfwb/wbxm/translate`, fd); }

};
